import { Order } from '../../order/models/order';

import { QualityBatch } from './quality-batch';
import { QualityAttachment } from './quality-attachment';

export enum ClaimStatus {
	DRAFT = 'claimstatus.draft',
	PENDING_NOT_PUSH = 'claimstatus.pendingnotpush',
	CREATED = 'claimstatus.created',
	PENDING_PUSH = 'claimstatus.pendingpush',
	PENDING = 'claimstatus.pending', // registered by SAP but not resolved
	CANCELLED = 'claimstatus.cancelled',
	PAID = 'claimstatus.paid',
	REFUSED = 'claimstatus.refused',
	REGWARNING = 'claimstatus.registeredwarning',
	UNKNOWN = 'claimstatus.unknowntype',
}

export const PENDING_STATUS_LIST = Object.freeze( // open issues
	[
		ClaimStatus.PENDING_NOT_PUSH,
		ClaimStatus.PENDING_PUSH,
		ClaimStatus.PENDING,
		ClaimStatus.UNKNOWN,
		ClaimStatus.CREATED
	]
);
export const CLOSED_STATUS_LIST = Object.freeze( // closed issues
	[ClaimStatus.CANCELLED, ClaimStatus.PAID, ClaimStatus.REFUSED, ClaimStatus.REGWARNING]
);

export const STATUS_TR = {
	/* eslint-disable @typescript-eslint/naming-convention */
	'claimstatus.draft': 'issue.draft',
	'claimstatus.pendingnotpush': 'issue.pending',
	'claimstatus.created': 'issue.pending',
	'claimstatus.pendingpush': 'issue.pending',
	'claimstatus.pending': 'issue.pending',
	'claimstatus.cancelled': 'global.closed',
	'claimstatus.paid': 'global.closed',
	'claimstatus.refused': 'global.closed',
	'claimstatus.registeredwarning': 'global.closed',
	'claimstatus.unknowntype': 'quapp.error'
	/* eslint-enable @typescript-eslint/naming-convention */
};

export const DECISION_TR = {
	/* eslint-disable @typescript-eslint/naming-convention */
	'claimstatus.draft': 'issue.draft',
	'claimstatus.created': 'claim.status.created',
	'claimstatus.pendingnotpush': 'issue.inprocess',
	'claimstatus.pendingpush': 'issue.inprocess',
	'claimstatus.pending': 'issue.inprocess',
	'claimstatus.cancelled': 'global.cancelled',
	'claimstatus.paid': 'quapp.process.closed.paid',
	'claimstatus.refused': 'quapp.process.closed.refused',
	'claimstatus.registeredwarning': 'quapp.process.closed.warning',
	'claimstatus.unknowntype': 'quapp.error',
	/* eslint-enable @typescript-eslint/naming-convention */
};

export const ISSUE_TYPE_TR = {
	warning: 'claim.warning',
	claim: 'issue.claim',
};

export const CLAIM_TYPE_TR = {
	ZL: 'claim.type.zl',
	ZR: 'claim.type.zr',
};

export interface QualityIssue {
	id: string;
	steeluserId: string;
	supplierIssueNumber: string;
	batches: QualityBatch[];
	attachments: QualityAttachment[];
	qtyRequested: number;
	weightUnitRequested: string;
	customerReference: string;
	customerArticleReference: string;
	customer: string;
	customerDefect: string;
	customerDefectDescription: string;
	customerDefectDetailed: string;
	customerDefectDetailedDescription: string;
	supplierDefect: string;
	supplierDefectDescription: string;
	sampleTarget: string;
	sampleTargetComment: string;
	sampleTargetDescription: string;
	supplierOrderNumber: string;
	supplierOrderItemNumber: number;
	customerOrderNumber: string;
	customerOrderItemNumber: number;
	comment: string;
	amountRequested?: number;
	currencyRequested: string;
	wantVisit: true;
	/** shouldn't be undefined -> manage with CRM the error case on IssueSteelUserStatus__c */
	status?: ClaimStatus;
	qtyAccepted: number;
	amountAccepted: string;
	currencyAccepted: string;
	supplierComment: string;
	issueType: string;
	creationDate: string;
	modificationDate: string;
	closedDate: string;
	creditNoteDate: string;
	order?: Order;
	origin: string;
	otherCostAmount: number;
	soldToDescription: string;
	shipToDescription: string;
	mill: string;
	millDescription: string;
	claimType: string;
}

export type FieldOfQualityIssue = keyof QualityIssue
	| `batches.${ keyof QualityIssue['batches'][number] }`
	| `attachments.${ keyof QualityIssue['attachments'][number] }`;
